import { BaseFeature, FeatureType } from '@core/shared/feature';
export class PflegethekeUsersBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@pflegetheke/users/feature","featureId":"pflegetheke-users"},
      abilityActions: false,
      dependencies: [],
      plugins: [
      // {forPlatform:'frontend', type:FeatureType.Permanent, pluginClassName:'PflegethekeUsersFrontendFeature'},
      // {forPlatform:'frontend-management', type:FeatureType.Dynamic, pluginClassName:'PflegethekeUsersFrontendManagementFeature', simpleAbilityCheck:'MANAGER' },
      // {forPlatform:'admin', type:FeatureType.Permanent, pluginClassName:'PflegethekeUsersFrontendAdminFeature'},
      {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeUsersBackendFeature'
      }
      // {forPlatform:'backend-admin', type:FeatureType.Permanent, pluginClassName:'PflegethekeUsersBackendAdminFeature'},
      ]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}